import React from 'react';

import { Table } from 'reactstrap';

import { TableMobileContainer } from './TableMobile.styles';

var TableMobile = function TableMobile(_ref) {
  var cols = _ref.cols,
      children = _ref.children,
      striped = _ref.striped,
      hover = _ref.hover;


  return React.createElement(
    TableMobileContainer,
    { cols: cols },
    React.createElement(
      Table,
      { striped: striped, hover: hover },
      React.createElement(
        'thead',
        null,
        React.createElement(
          'tr',
          null,
          cols.map(function (col) {
            return React.createElement(
              'th',
              { key: col.colID },
              col.colTitle
            );
          })
        )
      ),
      React.createElement(
        'tbody',
        null,
        children
      )
    )
  );
};

export default TableMobile;